import React, { useState, useEffect } from 'react';
import BackgroundPattern from './BackgroundPattern';
import { API_URL } from '../utils/Functions';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/public/testimonials?active=1`)
      .then(res => res.json())
      .then(data => {
        setTestimonials(data.data || []);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching testimonials:', err);
        setLoading(false);
      });
  }, []);
  return (
    <section className="section-padding bg-light position-relative overflow-hidden">
      <BackgroundPattern position="left" top="40%" />
      
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

        .test-section {
          font-family: 'Inter', sans-serif;
        }

        .test-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 30px;
        }

        @media (max-width: 991px) {
          .test-grid { grid-template-columns: 1fr; }
        }

        .test-card {
          background: #ffffff;
          border-radius: 20px;
          padding: 32px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 10px 30px rgba(15, 23, 42, 0.02);
          position: relative;
          transition: transform 0.25s, box-shadow 0.25s;
          text-align: left;
        }

        .test-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 16px 36px rgba(15, 23, 42, 0.05);
        }

        .test-rating {
          color: #CFA047;
          font-size: 14px;
          margin-bottom: 18px;
        }

        .test-review {
          font-size: 15px;
          color: #475569;
          line-height: 1.7;
          font-style: italic;
          margin-bottom: 24px;
        }

        .test-user-info {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .test-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid rgba(207, 160, 71, 0.3);
        }

        .test-name {
          font-size: 16px;
          font-weight: 700;
          color: #0f172a;
          margin: 0;
        }

        .test-role {
          font-size: 13px;
          color: #64748b;
          margin: 2px 0 0;
        }

        .test-quote-icon {
          position: absolute;
          bottom: 24px;
          right: 28px;
          color: rgba(207, 160, 71, 0.1);
          font-size: 48px;
          pointer-events: none;
        }
      `}</style>

      <div className="container position-relative z-1 test-section">
        <div className="row align-items-center mb-5">
          <div className="col-lg-6 text-start">
            <div
              className="d-inline-flex align-items-center gap-2 mb-3 px-4 py-2 rounded-pill shadow-sm"
              style={{
                background: '#fff',
                border: '1px solid #e8edf3',
                fontSize: '12px',
                fontWeight: 700,
                letterSpacing: '1.2px',
                textTransform: 'uppercase',
                color: '#CFA047'
              }}
            >
              <span style={{ width: 8, height: 8, background: '#CFA047', borderRadius: '50%', boxShadow: '0 0 8px rgba(207, 160, 71, 0.5)' }}></span>
              Client Testimonials
            </div>
            <h2 className="display-5 fw-bold" style={{ color: '#0f172a', letterSpacing: '-1.5px' }}>
              Hear What Our <span style={{ color: '#CFA047' }}>Clients</span> Say
            </h2>
          </div>
          <div className="col-lg-6 text-start text-lg-end mt-3 mt-lg-0">
            <p className="text-muted mb-0" style={{ fontSize: '15.5px', maxWidth: '480px', marginLeft: 'auto', lineHeight: '1.7' }}>
              We've helped over 5 Lakh businesses register and manage compliance across India. Check out some of our success stories.
            </p>
          </div>
        </div>

        <div className="test-grid">
          {loading ? (
            <div className="col-12 text-center py-5">
              <div className="spinner-border" style={{ color: '#CFA047' }} role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : testimonials.length === 0 ? (
            <div className="col-12 text-center text-muted py-5">
              No testimonials found.
            </div>
          ) : (
            testimonials.map((test, i) => (
              <div key={test.id || i} className="test-card">
                <div className="test-rating">
                  {Array.from({ length: test.rating || 5 }).map((_, idx) => (
                    <i key={idx} className="fa-solid fa-star me-1"></i>
                  ))}
                </div>
                
                <p className="test-review">
                  "{test.review}"
                </p>
                
                <div className="test-user-info">
                  {test.avatar && (
                    <img 
                      src={test.avatar.startsWith('http') ? test.avatar : `${API_URL}${test.avatar.startsWith('/') ? '' : '/'}${test.avatar}`}
                      alt={test.name} 
                      className="test-avatar" 
                    />
                  )}
                  <div>
                    <h6 className="test-name">{test.name}</h6>
                    <p className="test-role">{test.role}</p>
                  </div>
                </div>
                <i className="fa-solid fa-quote-right test-quote-icon"></i>
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
